'use client';

import React, { useCallback } from 'react';
import { AnimatedRange } from './AnimatedBar';
import { cn } from '@/lib/cn';

/* ================================================================
   统一动画滑杆
   ================================================================ */

interface SliderProps {
  value: number;
  onChange: (v: number) => void;
  min?: number;
  max?: number;
  step?: number;
  label?: string;
  /** 右侧显示当前值 */
  showValue?: boolean;
  /** 值格式化 */
  formatValue?: (v: number) => string;
  disabled?: boolean;
  className?: string;
}

export function Slider({
  value,
  onChange,
  min = 0,
  max = 100,
  step = 1,
  label,
  showValue = true,
  formatValue,
  disabled = false,
  className,
}: SliderProps) {

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange(Number(e.target.value));
    },
    [onChange]
  );

  const displayValue = formatValue ? formatValue(value) : String(value);

  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      {(label || showValue) && (
        <div className="flex items-center justify-between">
          {label && (
            <span className="cap-label">{label}</span>
          )}
          {showValue && (
            <span className="text-xs font-medium text-hr-text-secondary tabular-nums">
              {displayValue}
            </span>
          )}
        </div>
      )}
      <AnimatedRange
        min={min} max={max} step={step} value={value}
        onChange={handleChange} disabled={disabled}
        aria-label={label} aria-valuetext={displayValue}
      />
    </div>
  );
}
